import { render, staticRenderFns } from "./VisualDormitory.vue?vue&type=template&id=7bc6c6a2&scoped=true"
import script from "./VisualDormitory.vue?vue&type=script&lang=js"
export * from "./VisualDormitory.vue?vue&type=script&lang=js"
import style0 from "./VisualDormitory.vue?vue&type=style&index=0&id=7bc6c6a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc6c6a2",
  null
  
)

export default component.exports